import React from 'react';
import Accent from '@/components/typography/Accent';
import Paragraph from '@/components/typography/Paragraph';

const DataVisualization = () => (
  <>
    <Paragraph>Performance has to be measured, monitored and refined continually - it can’t be an afterthought and it should not only be the developer problem.</Paragraph>
    <Paragraph>
      It’s critical to have <Accent>clearly defined targets and performance metrics</Accent> so everyone is aware and take responsability of a new feature impact on performance.
    </Paragraph>
    <Paragraph>Over the past year I implemented performance testing on an authenticated app, as part of the CircleCI deployement process using Lighthouse and Puppeteer.</Paragraph>
    <Paragraph>It gives a good insight on how the app performs and ensure it stays under  <Accent>budget</Accent>, in term of <Accent>first contentful paint, speed index, time to interactive and bundle size</Accent>.</Paragraph>
  </>
);

DataVisualization.propTypes = {};

export default DataVisualization;
